import { mapGetters, mapActions } from 'vuex'
import { isArray, isEmpty, trim, getByteLen, deepCopy } from '@/common/js/utils'
import { getSession } from '@/common/js/api'
import { checkPlanName } from '@/api/common.model'
// 公共组件
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import CheckPlus from '@/components/mixcheck/check-plus'
import RadioItem from '@/components/mixcheck/radio-item'
import Moduler from '@/components/moduler'
import ErrorPop from '@/components/error-pop'
import InputLen from '@/components/input/input-len'
import InputNumberPlus from '@/components/input/input-number-plus'
import AutoComplete from '@/components/autocomplete/autocomplete'
import Affix from '@/components/affix.vue'

let Timer
const dynwords = ['日期', '时间', '定向包名', '创意组名', '账号简称']

export default {
  components: { Mixcheck, CheckItem, CheckPlus, RadioItem, Moduler, ErrorPop, InputLen, InputNumberPlus, AutoComplete, Affix },
  computed: {
    ...mapGetters('Kuaishoulocal', ['subCurrent', 'subModules']),
    adAccount() {
      const accounts = getSession('ad_account_ids') || []
      const ad = accounts.pop()
      if (ad) {
        const { id } = ad
        return id || this.account
      } else return this.account
    },
    accounts() {
      return getSession('ad_account_ids') || []
    }
  },
  methods: {
    ...mapActions('Kuaishoulocal', ['refreshDocTitle']),
    invalid(rules) {
      const arr = []
      const multRuleName = (name) => {
        const rule = name.split('/')
        if (rule.length > 3) return this[rule[0]][rule[1]][rule[2]][rule[3]]
        else if (rule.length > 2) return this[rule[0]][rule[1]][rule[2]]
        else return this[rule[0]][rule[1]]
      }
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? multRuleName(rule.name) : this[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else if (typeof ruleName === 'number') {
          param = length = ruleName
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? multRuleName(rule.relyon) : this[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          this.formErr = true
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (typeof param === 'string' || isArray(param)) {
          if (param && rule.max < length) {
            const msg = `${rule.desc}不能多于${rule.max}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (param && rule.min > length) {
            const msg = `${rule.desc}不能少于${rule.min}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        } else if (typeof param === 'number') {
          // 大小判断
          if (rule.max < length) {
            const msg = `${rule.desc}数值不能大于${rule.max}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (rule.min > length) {
            const msg = `${rule.desc}数值不能小于${rule.min}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    focusPlan() {
      Timer && clearTimeout(Timer)
    },
    blurPlan() {
      Timer = setTimeout(() => {
        this.checkPlan()
      }, 1000)
    },
    checkPlan() {
      const plan_name = deepCopy(this.plan.plan_name)
      if (isEmpty(plan_name)) return
      this.check = 'loading'
      checkPlanName({ planName: plan_name })
        .then((data) => {
          this.check = data ? 'success' : 'error'
        })
        .catch(() => {
          this.check = 'error'
        })
    },
    inputTrim(key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = parseFloat(val) * 1000
        val = Math.floor(val) / 1000
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    // 多选卡还原默认值
    multRadioChange(val, mult) {
      if (val === 'NONE') this.plan[mult] = JSON.parse(JSON.stringify([]))
    },
    beforeHandler() {
      window.onbeforeunload = function (event) {
        const msg = '您正在编辑内容，离开数据将丢失，确定要退出本页吗？'
        event.returnValue = msg
        return msg
      }
    },
    toTop() {
      const contentElem = window.document.querySelector('.ivu-layout-content')
      contentElem.scrollTop = 0
      contentElem.addEventListener('scroll', this.handleScroll)
    },
    handleScroll(e) {
      this.$store.commit('Kuaishoulocal/setScroll', e.target.scrollTop)
    },
    // 添加动态词
    appendTrend(word) {
      const title = deepCopy(this.plan.plan_name)
      const { selectionStart } = this.$refs.planinput[0].$refs.input.$refs.input
      const prefix = title.substring(0, selectionStart)
      const suffix = title.substring(selectionStart)
      if (title.indexOf(word) > -1) {
        this.$Message.error('不能使用重复的动态词')
        return
      }
      this.plan.plan_name = `${prefix}{${word}}${suffix}`
      this.validTrend()
      this.$refs.planinput[0].focus()
    },
    // 动态词验证
    validTrend() {
      const plan_name = deepCopy(this.plan.plan_name)
      if (isEmpty(plan_name)) return
      let dynErr = ''
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = plan_name.match(regexp)
      const count = (str, cut) => {
        if (typeof str !== 'string') return 0
        return str.split('').filter((ret) => ret === cut).length
      }
      if (count(plan_name, '{') !== count(plan_name, '}')) {
        dynErr = '动态词包格式错误'
      } else if (plan_name.replace(regexp, '').includes('{') || plan_name.replace(regexp, '').includes('{')) {
        dynErr = '动态词包标识{}不允许作为内容出现'
      } else if (isArray(values) && values.some((ret) => !this.dynwords.map((met) => `{${met}}`).includes(ret))) {
        dynErr = '动态词包不存在'
      } else if (isArray(values) && values.some((ret, i) => values.indexOf(ret) !== i)) {
        dynErr = '动态词包不能存在相同'
      }
      // 动态词位置
      let dynPos = []
      if (isArray(values)) {
        dynPos = values
          .filter((ret) => this.dynwords.map((met) => `{${met}}`).includes(ret))
          .map((m) => {
            const min = plan_name.indexOf(m)
            return [min, min + m.length]
          })
      }
      this.dynpos = dynPos
      this.dynErr = dynErr
    }
  },
  data() {
    return {
      check: null, // 计划名检查
      dynErr: '',
      dynpos: [], // 动态词位置
      dynwords: dynwords, // 动态词
      payTypeBag: [7],
      loading: null,
      saving: null,
      formErr: null,
      errRes: [],
      account: this.$store.state.Kuaishoulocal.accountId,
      media: Number(this.$store.state.Kuaishoulocal.media),
      opId: Number(this.$store.state.Kuaishoulocal.account)
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.beforeHandler()
      this.toTop()
      this.refreshDocTitle()
    })
  },
  beforeDestroy() {
    const contentElem = window.document.querySelector('.module-content')
    contentElem.removeEventListener('scroll', this.handleScroll)
  }
}
